export const TABLE_HEADER = {
  PRODUCT: 'Sản phẩm',
  PRICE: 'Đơn giá',
  QUANTITY: 'Số lượng',
  TOTAL: 'Số tiền',
  ACTION: 'Thao tác',
};

export const TABLE_COL = {
  MESSAGE: 'Miễn phí giao hàng khu vực TP. Hồ Chí Minh',
};

export const ACTION = {
  TOTAL: 'Tổng tiền ({amount} sản phẩm)',
  DISCOUNT: 'Chiết khấu ({discount}%)',
  GRAND_TOTAL: 'Thành tiền',
  BUY: 'Tiến hành đặt hàng',
  DELETE: 'Xoá',
};

export const ERROR = {
  MESSAGE: 'Có lỗi xảy ra vui lòng thử lại',
};
